import { FileType, FolderType } from '../AccountFiles';

export const sortItems = <T extends FileType | FolderType>(items: T[], sortedField: keyof T, asc: boolean): T[] => {
	if (!sortedField) return items;
	const key = sortedField;
	return [...items].sort((a, b) => {
		if (a[key] && b[key]) {
			if (a[key] < b[key]) return asc ? -1 : 1;
			if (a[key] > b[key]) return asc ? 1 : -1;
		}
		return 0;
	});
};

export const confirmationText = (
	totalFolders: number,
	totalFiles: number,
	name: string,
	lang: Record<string, string>
) => {
	if (totalFolders > 0 && totalFiles > 0) {
		return `${lang.delete} ${name} ${lang.with} ${totalFolders} ${
			totalFolders === 1 ? lang.folder : lang.folders
		} ${lang.and} ${totalFiles} ${totalFiles === 1 ? lang.file : lang.files}?`;
	}
	if (totalFolders > 0) {
		return `${lang.delete} ${lang.with} ${totalFolders} ${totalFolders === 1 ? lang.folder : lang.folders}?`;
	}
	return `${lang.delete} ${name} ${lang.with} ${totalFiles} ${totalFiles === 1 ? lang.file : lang.files}?`;
};
